export const DRIVER_FACE_PHOTO_MAX = 40;
